export default __webpack_public_path__ + "static/media/fish&chips-italic.8c9d6089.eot";